import Dropdown from './Dropdown.vue';
import DropdownItem from './DropdownItem.vue';

export default [
  Dropdown,
  DropdownItem,
];
